import { useTranslation } from "react-i18next";
import DetailedFeatureItem from "./DetailedFeatureItem";
import buildingProperties from "../../Images/buildingProperties.png"
import createComponents from "../../Images/createComponents.png"
import buildingStructure from "../../Images/buildingStructure.png"

export default function CalculationToolsFeaturesDetailed({ onTryDemoClickFunction: _onTryDemoClickFunction }: { onTryDemoClickFunction?: () => void }) {
    const { t } = useTranslation();

    const items = [
        {
            image: buildingProperties,
            title: t("EnterBuildingProperties"),
            text: t("EnterBuildingPropertiesFirstParagraph"),
            backgroundClass: "xl:bg-detailedFeaturesGlassOne xl:bg-cover xl:bg-center xl:bg-no-repeat rounded-[20px]"
        },
        {
            image: createComponents,
            title: t("CreateSpacesAndComponents"),
            text: t("CreateSpacesAndComponentsFirstParagraph"),
            backgroundClass: "bg-[#FF61041A] xl:bg-#F6F6F6"
        },
        {
            image: buildingStructure,
            title: t("ExportPdfFileAndGenerateReport"),
            text: t("ExportPdfFileAndGenerateReportFirstParagraph"),
            backgroundClass: "xl:bg-detailedFeaturesGlassTwo xl:bg-cover xl:bg-center xl:bg-no-repeat rounded-[20px]"
        },
    ];

    return (
        <div className="flex flex-col bg-#F6F6F6 pb-[30px] lg:pb-[60px] px-[30px] lg:px-[100px]">
            <h2 className="text-lg xl:text-2xl uppercase font-bold p-[30px] xl:p-[60px] text-center">{t("HowDoesTheProcessWithCalculationToolsWork")}</h2>
            {items.map((item, index) => (
                <DetailedFeatureItem
                    key={index}
                    image={item.image}
                    title={item.title}
                    text={item.text}
                    backgroundClass={item.backgroundClass}
                    index={index} />
            ))}
        </div>
    )
}